module.exports = __webpack_public_path__ + "static/media/happy-monkey-garuda.70fa8bf4.mp3";